import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFromApi, postToAPI } from "../../helpers/api";
import Auth from "../Auth";

const placeholder =
  "https://180dc.org/wp-content/uploads/2022/04/Blank-Avatar.png";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Artist(props) {  
  const { accessToken } = props;
  const [saving, setSaving] = useState(false);
  const [showShareLink, setShowShareLink] = useState(false);
  const [artistInfo, setArtistInfo] = useState({
    name: "",
    username: "",
    bio: "",
    website: "",
    userAvatar: "",
    nftImage: "",
    nftDescription: "",
  });

  useEffect(() => {
    if (accessToken) {
      loadArtistInfo();
    }
  }, [accessToken]);

  const loadArtistInfo = async () => {    
    const json = await getFromApi("artist", accessToken);
    // const json = await res.json();
    if (json) {
      setArtistInfo({
        name: json.name,
        username: json.username,
        bio: json.bio,
        website: json.website,
        userAvatar: json.userAvatar,
        nftImage: json.nftImage,
        nftName: json.nftName,
        nftDescription: json.nftDescription,
      });
    }
  };

  const handleChange = (e, key) => {
    const deepClone = JSON.parse(JSON.stringify(artistInfo));
    deepClone[key] = e.target.value;
    setArtistInfo(deepClone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const {
        name,
        username,
        bio,
        website,
        userAvatar,
        nftImage,
        nftName,
        nftDescription,
      } = artistInfo;
      if (
        !name ||
        !username ||
        !bio ||
        !website ||
        !userAvatar ||
        !nftImage ||
        !nftName ||
        !nftDescription
      ) {
        return alert("Please complete all fields");
      }
      const res = await postToAPI("artist", artistInfo, props.accessToken);
      console.log(res);
      setSaving(false);
      setShowShareLink(true);
    } catch (error) {
      console.log(error);
      setSaving(false);
      alert(error.message);
    }
  };

  const handlePhoto = async (e, type) => {    
    //  Upload to user's IPFS
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    // const result = await postToAPI("artists/avatar", formData, props.accessToken, true)
    // const res = await fetch(`http://localhost:3000/upload`, {
    //   method: "POST",
    //   body: formData,
    //   headers: {
    //     auth: `Bearer ${props.accessToken}`,
    //   },
    // });

    const json = await postToAPI("upload", formData, props.accessToken, true);
    // const json = await res.json();
    console.log(json);
    const deepClone = JSON.parse(JSON.stringify(artistInfo));
    deepClone[type] = json.url;
    setArtistInfo(deepClone);
  };

  if (props.accessToken) {
    return (
      <>
        <main className="mt-14 max-w-lg mx-auto pt-10 pb-12 px-4 lg:pb-16">
          <form onSubmit={handleSubmit}>
            <div className="space-y-6">
              <div>
                <h1 className="text-3xl font-serif leading-6 font-medium text-gray-900">
                  {artistInfo?.name
                    ? "Update artist profile NFT"
                    : "Set up artist profile NFT"}
                </h1>
                {artistInfo?.name ? (
                  <div>
                    <p className="mt-2 text-sm text-gray-500">
                      Your Artist Profile and SoundBasket NFT can be updated
                      here.
                    </p>
                    <Link
                      to={`/@${artistInfo.username}`}
                      className="underline font-sans text-sm"
                    >
                      Or view your artist unlock page
                    </Link>
                  </div>
                ) : (
                  <p className="mt-1 text-sm text-gray-500">
                    Let’s get started by filling in the information below to
                    create your artist profile page.
                  </p>
                )}
              </div>
              <div>
                <label
                  htmlFor="project-name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Artist name
                </label>
                <div className="mt-1">
                  <input
                    autoComplete="off"
                    type="text"
                    name="project-name"
                    id="project-name"
                    placeholder="Artist name"
                    className="block w-full border p-4 sm:text-sm border-gray-300 rounded-md"
                    value={artistInfo.name}
                    onChange={(e) => handleChange(e, "name")}
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="user-name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Artist username
                  <br />
                  <span className="text-muted font-xs text-gray">
                    *Choose a unique name that represents your profile
                  </span>
                </label>
                <div className="mt-1">
                  <input
                    autoComplete="off"
                    type="text"
                    name="user-name"
                    id="user-name"
                    placeholder="Artist username"
                    className="block w-full border p-4 sm:text-sm border-gray-300 rounded-md"
                    value={artistInfo.username}
                    onChange={(e) => handleChange(e, "username")}
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="description"
                  className="block text-sm font-medium text-gray-700"
                >
                  Artist bio
                </label>
                <div className="mt-1">
                  <textarea
                    id="description"
                    name="description"
                    rows={3}
                    placeholder="Artist bio"
                    className="block w-full border p-4 sm:text-sm border-gray-300 rounded-md"
                    value={artistInfo.bio}
                    onChange={(e) => handleChange(e, "bio")}
                  />
                </div>
              </div>

              <div
                className={`relative ${
                  artistInfo?.userAvatar ? "rounded-full" : "rounded-md"
                } overflow-hidden lg:block w-full m-auto`}
              >
                {artistInfo?.userAvatar ? (
                  <img
                    className="relative m-auto rounded-full w-40 h-40"
                    src={artistInfo.userAvatar}
                    alt=""
                  />
                ) : (
                  <div className="rounded-md p-6 flex justify-center align-center bg-gray-300 text-black font-sans font-bold">
                    Upload artist image
                  </div>
                )}
                <label
                  htmlFor="desktop-user-photo"
                  className="absolute inset-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center text-sm font-medium text-white opacity-0 hover:opacity-100 focus-within:opacity-100"
                >
                  <span>Change</span>
                  <span className="sr-only"> user photo</span>
                  <input
                    type="file"
                    id="desktop-user-photo"
                    name="user-photo"
                    onChange={(e) => handlePhoto(e, "userAvatar")}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md"
                  />
                </label>
              </div>
              <div>
                <label
                  htmlFor="nft-name"
                  className="block text-sm font-medium text-gray-700"
                >
                  SoundBasket NFT name
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="nft-name"
                    id="nft-name"
                    placeholder="SoundBasket NFT name"
                    className="block w-full border p-4 sm:text-sm border-gray-300 rounded-md"
                    value={artistInfo.nftName}
                    onChange={(e) => handleChange(e, "nftName")}
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="nft-description"
                  className="block text-sm font-medium text-gray-700"
                >
                  Soundbasket NFT description
                </label>
                <div className="mt-1">
                  <textarea
                    id="nft-description"
                    name="nft-description"
                    rows={3}
                    placeholder="Soundbasket NFT description"
                    className="block w-full border p-4 sm:text-sm border-gray-300 rounded-md"
                    value={artistInfo.nftDescription}
                    onChange={(e) => handleChange(e, "nftDescription")}
                  />
                </div>
              </div>

              <div className="space-y-2">
                <div className="space-y-1">
                  <label
                    htmlFor="add-website"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Website
                  </label>
                  <div className="flex">
                    <div className="flex-grow">
                      <input
                        type="text"
                        name="add-website"
                        id="add-website"
                        className="block w-full border p-4 sm:text-sm border-gray-300 rounded-md"
                        placeholder="www.website.com"
                        aria-describedby="add-website"
                        value={artistInfo.website}
                        onChange={(e) => handleChange(e, "website")}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`relative ${
                  artistInfo?.nftImage ? "rounded-full" : "rounded-md"
                } overflow-hidden lg:block w-full m-auto`}
              >
                {artistInfo?.nftImage ? (
                  <img
                    className="relative m-auto rounded-full w-40 h-40"
                    src={artistInfo.nftImage}
                    alt=""
                  />
                ) : (
                  <div className="rounded-md p-6 flex justify-center align-center bg-gray-300 text-black font-sans font-bold">
                    Upload NFT image
                  </div>
                )}
                <label
                  htmlFor="nft-photo"
                  className="absolute inset-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center text-sm font-medium text-white opacity-0 hover:opacity-100 focus-within:opacity-100"
                >
                  <span>Change</span>
                  <span className="sr-only"> NFT image photo</span>
                  <input
                    type="file"
                    id="nft-photo"
                    name="nft-photo"
                    onChange={(e) => handlePhoto(e, "nftImage")}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md"
                  />
                </label>
              </div>

              <div className="flex flex-col justify-center w-full">
                <button
                  type="submit"
                  className="w-full inline-flex justify-center p-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black"
                >
                  {saving ? "Saving" : "Done"}
                </button>
                {showShareLink && (
                  <div className="text-center mt-4">
                    <Link
                      to={`/@${artistInfo.username}`}
                      className="text-center underline font-sans text-sm"
                    >
                      View your artist unlock page
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </form>
        </main>
      </>
    );
  } else {
    return <Auth handleSession={props.handleSession} confirmMFA={props.confirmMFA} logUserIn={props.logUserIn} isAuthenticated={props.isAuthenticated} />;
  }
}
